let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6NVPy")).then(() => parcelRequire('394AZ'));